import React, { useContext, useMemo } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { comparePosition } from '../../../CMFW/grid/comparators/comparePosition';
import { LoadingGrid } from '../../../CMFW/layout/LoadingGrid';
import TextSearch from '../../../components/search/TextSearch';
import { IRefIds } from '../../../constants/refs';
import { useForceRender } from '../../../hooks/useForceRender';
import ExerciseModel from '../../../models/ExerciseModel';
import { ILessonOutlineCard, ILessonOutlineCycleActivityExercise } from '../../../types/lessonOutline';
import { IGridData } from '../../../types/models';
import LessonOutlineActivityExercise from '../cards/activities/LessonOutlineActivityExercise';
import { WrapperActivity } from '../cards/LessonOutlineActivity';
import LessonOutlineContext from '../context/LessonOutlineContext';

type IProps = {
  courseId: number;
};

const LessonOutlineSearchExercise: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const exerciseModel = useMemo(() => new ExerciseModel({ render: forceRender, courseId: props.courseId }), [
    forceRender,
    props.courseId,
  ]);
  const lessonOutlineContext = useContext(LessonOutlineContext);

  const gridData = exerciseModel.gridData.sort((a, b) => comparePosition(a.position, b.position));

  return (
    <Wrapper>
      <ModuleContext.Provider value={exerciseModel}>
        <TextSearch />
        <Droppable
          isDropDisabled={true}
          droppableId={`${IRefIds.exercise}-bank`}
          direction={'vertical'}
          type={ILessonOutlineCard.ACTIVITY}
        >
          {(providedDroppable) => (
            <Wrapper>
              <WrapperResult {...providedDroppable.droppableProps} ref={providedDroppable.innerRef}>
                {gridData.map((exercise: IGridData, index: number) => (
                  <Draggable
                    isDragDisabled={!lessonOutlineContext.DNDEnabled}
                    draggableId={`${IRefIds.exercise}-${exercise.id}`}
                    index={index}
                    key={`${IRefIds.exercise}-${index}`}
                  >
                    {(provided) => (
                      <WrapperActivity
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        extraWide
                      >
                        <LessonOutlineActivityExercise activity={exercise as ILessonOutlineCycleActivityExercise} />
                      </WrapperActivity>
                    )}
                  </Draggable>
                ))}
                {providedDroppable.placeholder}
              </WrapperResult>
              <LoadingGrid />
            </Wrapper>
          )}
        </Droppable>
      </ModuleContext.Provider>
    </Wrapper>
  );
};

export default LessonOutlineSearchExercise;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  margin-right: 10px;
  position: relative;
`;

const WrapperResult = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: start;
  overflow-y: auto;
`;
